export default "__VITE_ASSET__4b03cfe1__"